import React from 'react';
import { Card, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { ATTACHMENT_TRANSFER } from '@/datasets/attachments/constants';

const RequestAttachmentCardItemExtra = ({ transferable }) => (
  <Card.Content extra>
    <span>
      <Icon name={ATTACHMENT_TRANSFER[transferable].icon} />
      <FormattedMessage id={`dataset.attachments.transferable.verbose.${transferable}`} />
    </span>
  </Card.Content>
);

export default RequestAttachmentCardItemExtra;
